import { Type } from "@scalar/typebox";
const XScalarSecretTokenSchema = Type.Object({
  "x-scalar-secret-token": Type.Optional(Type.String())
});
const XScalarSecretHTTPSchema = Type.Object({
  "x-scalar-secret-username": Type.Optional(Type.String()),
  "x-scalar-secret-password": Type.Optional(Type.String())
});
export {
  XScalarSecretHTTPSchema,
  XScalarSecretTokenSchema
};
//# sourceMappingURL=x-scalar-security-secrets.js.map
